import Reveal from "@/components/site/Reveal";
import { LeafMark } from "@/components/site/Motifs";

/**
 * SectionHeader, editorial section title with an overline + serif heading + optional intro.
 * Reveals gently on scroll and carries a small leaf accent for a handcrafted feel.
 */
export default function SectionHeader({
  overline,
  title,
  intro,
  align = "left",
  tone = "light",
  testId,
}) {
  const alignClass = align === "center" ? "text-center mx-auto" : "text-left";
  const dark = tone === "dark";

  return (
    <Reveal
      className={`${alignClass} max-w-2xl mb-12 sm:mb-16`}
    >
      <div data-testid={testId || "section-header"}>
        {overline && (
          <div className={`flex items-center gap-2.5 mb-4 ${align === "center" ? "justify-center" : ""}`}>
            <LeafMark size={16} className={dark ? "text-sage-400" : "text-sage-500"} />
            <span
              className={
                dark
                  ? "text-xs font-semibold uppercase tracking-[0.22em] text-sage-300 font-sans"
                  : "overline"
              }
            >
              {overline}
            </span>
          </div>
        )}
        <h2
          className={`font-serif text-4xl sm:text-5xl lg:text-[3.4rem] tracking-tight leading-[1.05] ${
            dark ? "text-sand-50" : "text-forest-950"
          }`}
        >
          {title}
        </h2>
        {intro && (
          <p
            className={`mt-6 text-lg leading-[1.8] ${
              dark ? "text-sand-200/85" : "text-forest-700"
            }`}
          >
            {intro}
          </p>
        )}
      </div>
    </Reveal>
  );
}
